import {cssTheme} from '@yandex-delivery/blocks';
import {css} from '@yandex-delivery/blocks/theme/css'
import {spacing} from '@yandex-delivery/blocks/theme/theme'

export const footerClasses = {
  root: css`
    text-decoration: underline;
    // TODO: Добавить цвет в cssTheme
    color: #F2F2F2;
    opacity: 0.6;

    &:hover, &:active {
      text-decoration: none;

      transition: all 0.15s ease-out;
      color: ${cssTheme.default.day.everWhite};
      opacity: 1;
    }
  `,
  size_s: css`
    font-size: ${spacing(1.75)};
    line-height: ${spacing(2.5)};
  `,
  size_m: css`
    font-size: ${spacing(2)};
    line-height: ${spacing(2.5)};
  `,
}
